import { ItemDropdown } from './models/activity-log';

export const APPROVAL_MODULE = {
  approvalRequests: {
    value: 'APPROVAL_REQUESTS',
    label: 'Approval requests',
    icon: 'sctr-icon-layers-three-01',
    path: '/approval-requests'
  },
  ota: { value: 'OTA', label: 'OTA', icon: 'sctr-icon-share-07', path: '/ota' },
  censorManagement: {
    value: 'CENSOR_MANAGEMENT',
    label: 'Censor Management',
    icon: 'sctr-icon-stand',
    path: '/censor-management'
  },
  appealManagement: {
    value: 'APPEAL_MANAGEMENT',
    label: 'Appeal management',
    icon: 'sctr-icon-file-search-02',
    path: '/appeal-management'
  }
};

export const API_PROCESSING_POLLING_CONFIG = {
  responseValue: 'is processing',
  maxRetries: 5,
  delay: 2000
};

export const MAX_POST_LENGTH = 260;
export const MAX_CAPTION_LENGTH = 80;
export const MAX_RESOLUTION_OF_POST = 703;
export const MAX_TRUNCATED_TEXT_HEIGHT = 100;
export const MAX_QTY_REACTIONS_STORAGE = 1000;
export const VIDEO_WIDTH_TO_SHOW_CONTROLLER = 792;

export const CREATE_ADS_PREVIEW = {
  FEEDS: {
    TITLE: 'Feeds',
    INDEX: 0
  },
  SEARCH: {
    TITLE: 'Search',
    INDEX: 1
  },
  STORY: {
    TITLE: 'Story',
    INDEX: 2
  },
  PANEL_1: {
    TITLE: 'Display panel 1',
    INDEX: 3
  },
  PANEL_2: {
    TITLE: 'Display panel 2',
    INDEX: 4
  },
  SPONSORED: {
    TITLE: 'Sponsored',
    INDEX: 5
  },
  VIDEO_ADS: {
    TITLE: 'Video ads',
    INDEX: 6
  }
};

export const FILE_TYPES = {
  image: 'image',
  video: 'video',
  application: 'application'
};

export const ADS_PREVIEW = {
  FEEDS: 'FEEDS',
  SEARCH: 'SEARCH',
  STORY: 'STORY',
  DISPLAY_PANEL_1: 'DISPLAY_PANEL_1',
  DISPLAY_PANEL_2: 'DISPLAY_PANEL_2',
  SPONSORED_BY: 'SPONSORED_BY'
};

export const DAY_TIME_UNITS = {
  milisecond: 'milisecond',
  second: 'second',
  minute: 'minute',
  hour: 'hour',
  day: 'day'
};

export const UserStatus = {
  inactive: {
    id: 'INACTIVE',
    label: 'Inactive',
    icon: 'sctr-icon-check-circle'
  },
  active: {
    id: 'ACTIVE',
    icon: 'sctr-icon-check-circle',
    label: 'Activate'
  },
  block: {
    id: 'BLOCKED',
    icon: 'sctr-icon-lock-03',
    label: 'Blocked'
  },
  limit: {
    id: 'LIMITED',
    icon: 'sctr-icon-alert-hexagon',
    label: 'Limited'
  },
  delete: {
    id: 'DELETE',
    label: 'Delete',
    icon: 'sctr-icon-trash-02'
  },
  edit: {
    id: 'EDIT',
    label: 'Edit',
    icon: 'sctr-icon-edit-05'
  }
};

export const UserRoles = [
  {
    name: 'User',
    code: 'USER'
  },
  {
    name: 'Restricted',
    code: 'RESTRICTED'
  },
  {
    name: 'Administrator',
    code: 'ADMINISTRATOR'
  },
  {
    name: 'Admin',
    code: 'ADMIN'
  }
];

export const Genders: ItemDropdown[] = [
  { label: 'None', value: null },
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' }
];

export const PhoneNumber: ItemDropdown[] = [
  { label: 'VN (+84)', value: 'VN' },
  { label: 'Lao (+85)', value: 'L' }
];

export const Locations: any[] = [
  { value: 'Ho Chi Minh' },
  { value: 'Ha Noi' },
  { value: 'Binh Dinh' },
  { value: 'Da Nang' },
  { value: 'Khanh Hoa' },
  { value: 'Ben Tre City' }
];

export const Hometowns: any[] = [
  { name: 'Da Nang', value: 'DN' },
  { name: 'Khanh Hoa', value: 'KH' }
];

export const Links: any[] = [
  { value: 'Facebook' },
  { value: 'Twitter' },
  { value: 'LinkedIn' },
  { value: 'Instagram' }
];

export const RelationshipStatus: any[] = [
  { label: 'None', value: null },
  { label: 'Single', value: 'Single' },
  { label: 'In Relationship', value: 'In Relationship' },
  { label: 'Married', value: 'Married' },
  { label: 'In a civil union', value: 'In a civil union' },
  { label: 'Separated', value: 'Separated' },
  { label: 'Divorced', value: 'Divorced' },
  { label: 'Widowed', value: 'Widowed' }
];

export const Status: any[] = [
  { name: 'Active', value: 'A' },
  { name: 'Inactive', value: 'I' },
  { name: 'Blocked', value: 'B' },
  { name: 'Limited', value: 'L' },
  { name: 'Activate', value: 'AT' }
];

export const ActivityLogItem: any[] = [
  {
    'name': 'commented',
    'icon': 'sctr-icon-message-dots-square',
    'color': 'bg-palette-blue-50',
    'color-icon': 'text-palette-blue-600',
    'valueFilter': 'Comment'
  },
  {
    'name': 'shared',
    'icon': 'sctr-icon-repeat-01',
    'color': 'bg-palette-emerald-50',
    'color-icon': 'text-palette-emerald-600',
    'valueFilter': 'Share'
  },
  {
    'name': 'created',
    'icon': 'sctr-icon-flag-03',
    'color': 'bg-palette-blue-light-50',
    'color-icon': 'text-palette-blue-light-500',
    'valueFilter': 'Post'
  },
  {
    'name': 'reported',
    'icon': 'sctr-icon-alert-triangle',
    'color': 'bg-[#EAECF5]',
    'color-icon': 'text-[#363F72]',
    'valueFilter': 'Report'
  },
  {
    'name': 'sent coins',
    'icon': 'sctr-icon-coins-hand',
    'color': 'bg-palette-amber-50',
    'color-icon': 'text-palette-amber-500',
    'valueFilter': 'Gift'
  },
  {
    'name': 'reacted',
    'icon': 'sctr-icon-heart',
    'color': 'bg-palette-pink-50',
    'color-icon': 'text-palette-pink-600',
    'valueFilter': 'React'
  },
  // TODO - No UI for each element below
  {
    'name': 'edited',
    'icon': '',
    'color': '',
    'color-icon': '',
    'valueFilter': 'Edit'
  },
  {
    'name': 'blocked',
    'icon': '',
    'color': '',
    'color-icon': '',
    'valueFilter': 'Block'
  },
  {
    'name': 'deleted',
    'icon': '',
    'color': '',
    'color-icon': '',
    'valueFilter': 'Delete'
  },
  {
    'name': 'activated',
    'icon': '',
    'color': '',
    'color-icon': '',
    'valueFilter': 'Activate'
  }
];

export const DefaultPaginator = {
  numberRowPerPage: 10,
  rowsPerPageOptions: [10, 20, 30]
};

export const POST_TYPE = {
  normal: 'NORMAL',
  share: 'SHARE',
  album: 'ALBUM',
  link: 'LINK',
  poll: 'POLL',
  user: 'USER',
  livestream: 'LIVESTREAM',
  suggestion: 'SUGGESTION',
  ads: 'ADS',
  avatar: 'AVATAR',
  cover: 'COVER',
  reel: 'REEL',
  shareReels: 'SHARE_REEL'
};

export const POST_PATTERN = {
  normal: 'NORMAL',
  share: 'SHARE',
  album: 'ALBUM',
  link: 'LINK'
};

export const MEDIA_TYPE = {
  image: 'IMAGE',
  video: 'VIDEO'
};

export const FILE_EXTENSION = {
  image: '.webp',
  video: '.webm',
  mp4: '.mp4'
};

export const LAYOUT_TYPE = {
  vertical: 'VERTICAL',
  horizontal: 'HORIZONTAL',
  sidelong: 'SIDELONG',
  central: 'CENTRAL'
};

export const MEDIA_FILE_SIZE_LIMITS_BYTES = {
  image: 5242880,
  video: 104857600
};

export const MEDIA_FILE_FORMAT_LIMITS = {
  image: [
    'image/avif',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/jpg',
    'image/bmp',
    'image/svg+xml',
    'image/webp',
    'image/tiff'
  ],
  video: [
    'video/mp4',
    'video/mpeg',
    'video/ogg',
    'video/webm',
    'video/3gpp',
    'video/x-msvideo',
    'video/x-ms-wmv',
    'video/quicktime'
  ]
};

export const TOAST_MESSAGE_SEVERITY_LEVELS = {
  warn: 'warn',
  info: 'info',
  success: 'success',
  error: 'error'
};

export const TOAST_MESSAGE_LIFETIME_DURATIONS = {
  short: 2000,
  medium: 5000,
  long: 7000
};

export const APPROVER_TYPE = {
  superAdmin: 'SuperAdmin',
  adminGroup: 'AdminGroup',
  adminPage: 'AdminPage'
};

export const OBJECT_TYPE = {
  post: 'Post',
  group: 'Group',
  page: 'Page',
  tour: 'Tour',
  rating: 'Rating',
  comment: 'Comment',
  food: 'Food',
  hotel: 'Hotel',
  car: 'Car',
  mapPlace: 'Mapplace',
  tourAgency: 'Touragency',
  tourRating: 'Tourrating',
  pricingTour: 'Pricingtour',
  tourComment: 'Tour_comment',
  carRating: 'Carrating',
  requestOpenCar: 'Request_open_car',
  tourLegal: 'Tour_legal',
  carLegal: 'Car_legal'
};

export const PRIVACY = {
  public: 'PUBLIC',
  private: 'PRIVATE',
  friends: 'FRIENDS',
  friendExcept: 'FRIEND_EXCEPT',
  groupMembers: 'GROUP_MEMBERS'
};

export const PRIVACY_OPTIONS = [
  { privacy: PRIVACY.public, label: 'Public', icon: 'sctr-icon-globe-04' },
  { privacy: PRIVACY.private, label: 'Private', icon: 'sctr-icon-user-01' },
  { privacy: PRIVACY.friends, label: 'Friends', icon: 'sctr-icon-users-01' },
  { privacy: PRIVACY.friendExcept, label: 'Friend Except', icon: 'sctr-icon-settings-02' }
];

export const GROUP_PRIVACY_CONTEXTS = {
  public: { label: 'COMMON.PUBLIC', value: 'Public', icon: 'sctr-icon-globe-01' },
  private: { label: 'COMMON.PRIVATE', value: 'Private', icon: 'sctr-icon-solid-lock-02' }
};

export const MODULE_TYPE = {
  verificationRequest: 'Verification request',
  comments: 'Comments',
  fanpage: 'Fanpage',
  group: 'Group',
  posts: 'Posts'
};

export const POST_STATUSES = {
  none: 'NONE',
  new: 'NEW',
  pending: 'PENDING',
  edited: 'EDITED',
  warning: 'WARNING',
  deleted: 'DELETED'
};

export const PAGE_SIZE_OPTIONS = [
  { label: '10', size: 10 },
  { label: '30', size: 30 },
  { label: '50', size: 50 }
];

export const PAGE_NUM_DEFAULT = 0;
export const PAGE_SIZE_DEFAULT = 10;
export const TOTAL_ELEMENT_DEFAULT = 0;

export const GROUP_OF_POST_STATUSES = {
  timeline: [POST_STATUSES.new, POST_STATUSES.edited, POST_STATUSES.warning],
  statistic: [POST_STATUSES.new, POST_STATUSES.edited, POST_STATUSES.warning],
  pending: [POST_STATUSES.pending]
};

export const SORT_BY_DATE = {
  DESCENDING: 'DESCENDING',
  ASCENDING: 'ASCENDING'
};

export const REPORT_STATUS = {
  NONE: 'NONE',
  REPORTED: 'REPORTED',
  REPORTING: 'REPORTING'
};

export const REPORT_STATUS_OBJECT = {
  ALL: 'All status',
  APPROVED: 'APPROVED',
  NEW: 'NEW',
  EDIT: 'EDIT',
  REPORT: 'REPORT',
  KEPT: 'KEPT',
  WARNED: 'WARNED',
  DELETED: 'DELETED',
  REPORTING: 'REPORTING',
  EDITED: 'EDITED',
  BLOCKED: 'BLOCKED',
  SUGGESTED: 'SUGGESTED',
  REJECTED: 'REJECTED',
  SALES_APPROVED: 'SALES_APPROVED',
  LEGAL_APPROVED: 'LEGAL_APPROVED'
};

export const PRIORITY_OBJECT = {
  ALL: 'All priority',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
};

export const PRIORITY_OBJECT_COLOR = {
  GREEN: 'GREEN',
  YELLOW: 'YELLOW',
  RED: 'RED'
};

export const APPROVAL_OPTIONS = {
  NEW: {
    NAME: 'NEW',
    CODE: REPORT_STATUS_OBJECT.NEW
  },
  EDIT: {
    NAME: 'EDITED',
    CODE: REPORT_STATUS_OBJECT.EDIT
  },
  REPORTING: {
    NAME: 'REPORTING',
    CODE: REPORT_STATUS_OBJECT.REPORT
  }
};

export const REVIEW_OPTIONS = {
  KEPT: {
    NAME: 'KEPT',
    CODE: REPORT_STATUS_OBJECT.KEPT
  },
  WARNED: {
    NAME: 'WARNED',
    CODE: REPORT_STATUS_OBJECT.WARNED
  },
  DELETED: {
    NAME: 'DELETED',
    CODE: REPORT_STATUS_OBJECT.DELETED
  },
  SUGGESTED: {
    NAME: 'SUGGESTED',
    CODE: REPORT_STATUS_OBJECT.SUGGESTED
  },
  BLOCKED: {
    NAME: 'BLOCKED',
    CODE: REPORT_STATUS_OBJECT.BLOCKED
  },
  REJECTED: {
    NAME: 'REJECTED',
    CODE: REPORT_STATUS_OBJECT.REJECTED
  },
  APPROVED: {
    NAME: 'APPROVED',
    CODE: REPORT_STATUS_OBJECT.APPROVED
  },
  APPROVED_SELLING: {
    NAME: 'SALES_APPROVED',
    CODE: REPORT_STATUS_OBJECT.SALES_APPROVED
  },
  APPROVED_LEGALITY: {
    NAME: 'LEGAL_APPROVED',
    CODE: REPORT_STATUS_OBJECT.LEGAL_APPROVED
  }
};

export const REVIEW_OPTIONS_PROFILE = {
  KEPT: REVIEW_OPTIONS.KEPT,
  WARNED: REVIEW_OPTIONS.WARNED,
  BLOCKED: {
    NAME: 'BLOCKED',
    CODE: REPORT_STATUS_OBJECT.BLOCKED
  }
};

export const OPTIONS_FILTER_REVIEW_LIST_BY_MODULE = {
  POST: [
    REVIEW_OPTIONS.KEPT,
    REVIEW_OPTIONS.WARNED,
    REVIEW_OPTIONS.DELETED,
    REVIEW_OPTIONS.SUGGESTED
  ],
  PRODUCT: [
    REVIEW_OPTIONS.DELETED,
    REVIEW_OPTIONS.WARNED,
    REVIEW_OPTIONS.KEPT,
    REVIEW_OPTIONS.BLOCKED
  ],
  COMMENT: [REVIEW_OPTIONS.KEPT, REVIEW_OPTIONS.DELETED],
  FANPAGE: [REVIEW_OPTIONS.BLOCKED, REVIEW_OPTIONS.WARNED, REVIEW_OPTIONS.KEPT],
  GROUP: [REVIEW_OPTIONS.BLOCKED, REVIEW_OPTIONS.WARNED, REVIEW_OPTIONS.KEPT],
  STORY: [REVIEW_OPTIONS.DELETED, REVIEW_OPTIONS.WARNED, REVIEW_OPTIONS.KEPT],
  LIVESTREAM: [REVIEW_OPTIONS.DELETED, REVIEW_OPTIONS.WARNED, REVIEW_OPTIONS.KEPT],
  PROFILE: [REVIEW_OPTIONS.BLOCKED, REVIEW_OPTIONS.WARNED, REVIEW_OPTIONS.KEPT],
  ADVERTISEMENT: [REVIEW_OPTIONS.BLOCKED, REVIEW_OPTIONS.WARNED, REVIEW_OPTIONS.KEPT],
  REQUEST_OPEN_SHOP: [REVIEW_OPTIONS.REJECTED, REVIEW_OPTIONS.APPROVED_SELLING],
  REQUEST_OPEN_SHOP_LEGAL: [REVIEW_OPTIONS.REJECTED, REVIEW_OPTIONS.APPROVED_LEGALITY],
  REQUEST_OPEN_RESTAURANT: [REVIEW_OPTIONS.REJECTED, REVIEW_OPTIONS.APPROVED],
  REQUEST_OPEN_CAR: [REVIEW_OPTIONS.REJECTED, REVIEW_OPTIONS.APPROVED],
  TOURAGENCY: [REVIEW_OPTIONS.REJECTED, REVIEW_OPTIONS.APPROVED],
  HOTEL_AGENCY: [REVIEW_OPTIONS.REJECTED, REVIEW_OPTIONS.APPROVED],
  TOUR: [
    REVIEW_OPTIONS.KEPT,
    REVIEW_OPTIONS.BLOCKED,
    REVIEW_OPTIONS.WARNED,
    REVIEW_OPTIONS.DELETED
  ],
  PRICINGTOUR: [
    REVIEW_OPTIONS.KEPT,
    REVIEW_OPTIONS.BLOCKED,
    REVIEW_OPTIONS.WARNED,
    REVIEW_OPTIONS.DELETED
  ],
  TOUR_LEGAL: [REVIEW_OPTIONS.APPROVED, REVIEW_OPTIONS.REJECTED],
  CAR_LEGAL: [REVIEW_OPTIONS.APPROVED, REVIEW_OPTIONS.REJECTED],
  HOTEL_LEGAL: [REVIEW_OPTIONS.REJECTED, REVIEW_OPTIONS.APPROVED]
};

export const PRIORITY_REPORT = {
  GREEN: {
    NAME: 'HIGH',
    COLOR: 'bg-palette-emerald-600',
    CODE: 'GREEN'
  },
  YELLOW: {
    NAME: 'MEDIUM',
    COLOR: 'bg-palette-yellow-500',
    CODE: 'YELLOW'
  },
  RED: {
    NAME: 'LOW',
    COLOR: 'bg-palette-red-600',
    CODE: 'RED'
  }
};

export const PRIORITY_REPORT_BY_NAME = {
  HIGH: {
    NAME: 'HIGH',
    COLOR: 'bg-palette-emerald-600',
    CODE: 'GREEN'
  },
  MEDIUM: {
    NAME: 'MEDIUM',
    COLOR: 'bg-palette-yellow-500',
    CODE: 'YELLOW'
  },
  LOW: {
    NAME: 'LOW',
    COLOR: 'bg-palette-red-600',
    CODE: 'RED'
  }
};

export const MODULE_NAME = {
  SOCIAL: 'Social',
  BOOKING: 'Booking',
  SHOPPING: 'Shopping'
};

export const OVERVIEW_PROFILE = [
  {
    label: 'COMMON.FRIENDS',
    number: 25
  },
  {
    label: 'APPROVAL_REQUESTS.VERIFICATION_REQUEST.REPORT_SUMMARY.REWARD_COINS',
    number: 588
  },
  {
    label: 'APPROVAL_REQUESTS.VERIFICATION_REQUEST.REPORT_SUMMARY.GROUPS_JOINED',
    number: 12
  },
  {
    label: 'APPROVAL_REQUESTS.VERIFICATION_REQUEST.REPORT_SUMMARY.REPORTS',
    number: 3
  }
];

export const OVERVIEW_BUSINESS = [
  {
    label: 'COMMON.FOLLOWING',
    number: 534
  },
  {
    label: 'APPROVAL_REQUESTS.VERIFICATION_REQUEST.REPORT_SUMMARY.REWARD_COINS',
    number: 588
  },
  {
    label: 'APPROVAL_REQUESTS.VERIFICATION_REQUEST.REPORT_SUMMARY.REPORTS',
    number: 3
  }
];

export const ModerateRole = {
  SUPER_ADMIN: {
    name: 'Super Admin',
    code: 'SUPER_ADMIN'
  },
  ADMIN: {
    name: 'Admin',
    code: 'ADMIN'
  },
  MANAGER: {
    name: 'Manager',
    code: 'MANAGER'
  },
  LEADER: {
    name: 'Leader',
    code: 'LEADER'
  },
  MEMBER: {
    name: 'Member',
    code: 'MEMBER'
  },
  COLLABORATORS: {
    name: 'Collaborators',
    code: 'COLLABORATORS'
  }
};

export const MODULE_ADMIN = 'MODULE_ADMIN';

export const MANAGEMENT_ROLES = [
  {
    name: ModerateRole.SUPER_ADMIN.name,
    code: ModerateRole.SUPER_ADMIN.code,
    level: 30
  },
  {
    name: ModerateRole.ADMIN.name,
    code: ModerateRole.ADMIN.code,
    level: 25
  },
  {
    name: ModerateRole.MANAGER.name,
    code: ModerateRole.MANAGER.code,
    level: 20
  },
  {
    name: ModerateRole.LEADER.name,
    code: ModerateRole.LEADER.code,
    level: 15
  },
  {
    name: ModerateRole.MEMBER.name,
    code: ModerateRole.MEMBER.code,
    level: 10
  },
  {
    name: ModerateRole.COLLABORATORS.name,
    code: ModerateRole.COLLABORATORS.code,
    level: 5
  }
];

export const COMMENT_TYPES = {
  POST: 'POST',
  STORY: 'STORY',
  LIVESTREAM: 'LIVESTREAM',
  REEL: 'REEL',
  MEDIA: 'MEDIA'
};

export const VERIFICATION_TYPE = {
  profile: 'PROFILE',
  business: 'BUSINESS',
  businessPage: 'BUSINESS_PAGE',
  businessAccount: 'BUSINESS_ACCOUNT'
};

export const AVATAR_TYPE = {
  ringWithBorder: 'RING_WITH_BORDER',
  ring: 'RING',
  whiteBorder: 'WHITE_BORDER',
  grayBorder: 'GRAY_BORDER'
};

export const AVATAR_SIZE = {
  desktopProfile: {
    widthHeight: 'w-[160px] h-[160px]',
    ringPadding: 'p-1',
    initialsAvatar: 'text-6xl font-bold'
  },
  mobileProfile: {
    widthHeight: 'w-[140px] h-[140px]',
    ringPadding: 'p-[3px]',
    initialsAvatar: 'text-6xl font-bold'
  },
  small: {
    widthHeight: 'w-[46px] h-[46px]',
    ringPadding: 'p-0',
    initialsAvatar: 'text-lg font-bold'
  },
  tiny: {
    widthHeight: 'w-6 h-6',
    ringPadding: 'p-[1px]',
    initialsAvatar: 'text-xs font-bold'
  },
  fanpageList: {
    widthHeight: 'w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24',
    ringPadding: 'p-[1px]',
    initialsAvatar: 'text-lg font-bold'
  },
  overviewAvatar: {
    widthHeight: 'w-16 h-16',
    ringPadding: 'p-[1px]',
    initialsAvatar: 'text-2xl font-bold'
  }
};

export const OVERVIEW_LIST: string[] = [
  'friend',
  'follower',
  'coins',
  'group_join',
  'post',
  'event',
  'report'
];

export const POLL_STATUS = {
  INCOMING: 'INCOMING',
  ONGOING: 'ONGOING',
  END: 'END'
};

export const POLL_TYPE = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
  GROUP: 'GROUP'
};

export const POLL_VOTING_TYPE = {
  NORMAL: 'NORMAL',
  COINS: 'COINS'
};

export const BADGE_TYPE = {
  star: 'SOCTRIP_STAR',
  master: 'SOCTRIP_MASTER',
  xu: 'SOCTRIP_XU',
  buyer: 'SOCTRIP_BUYER'
};

export const BADGE_RANK = {
  bronze: 'BRONZE',
  silver: 'SILVER',
  gold: 'GOLD',
  diamond: 'DIAMOND'
};

export const BADGE_CONTEXTS = [
  {
    type: BADGE_TYPE.star,
    rank: BADGE_RANK.bronze,
    icon: 'assets/icons/badge/bronze_star.svg',
    color: '#879DC2',
    label: 'Bronze Star'
  },
  {
    type: BADGE_TYPE.star,
    rank: BADGE_RANK.silver,
    icon: 'assets/icons/badge/silver_star.svg',
    color: '#2970FF',
    label: 'Silver Star'
  },
  {
    type: BADGE_TYPE.star,
    rank: BADGE_RANK.gold,
    icon: 'assets/icons/badge/gold_star.svg',
    color: '#FABC05',
    label: 'Gold Star'
  },
  {
    type: BADGE_TYPE.star,
    rank: BADGE_RANK.diamond,
    icon: 'assets/icons/badge/diamond_star.svg',
    color: '#7A5AF8',
    label: 'Diamond Star'
  },
  {
    type: BADGE_TYPE.master,
    rank: BADGE_RANK.bronze,
    icon: 'assets/icons/badge/bronze_master.svg',
    color: '#F38F33',
    label: 'Bronze Master'
  },
  {
    type: BADGE_TYPE.master,
    rank: BADGE_RANK.silver,
    icon: 'assets/icons/badge/silver_master.svg',
    color: '#879DC2',
    label: 'Silver Master'
  },
  {
    type: BADGE_TYPE.master,
    rank: BADGE_RANK.gold,
    icon: 'assets/icons/badge/gold_master.svg',
    color: '#FABC05',
    label: 'Gold Master'
  },
  {
    type: BADGE_TYPE.master,
    rank: BADGE_RANK.diamond,
    icon: 'assets/icons/badge/diamond_master.svg',
    color: '#27B6FE',
    label: 'Diamond Master'
  }
];

export const NIL_UUID = '00000000-0000-0000-0000-000000000000';

export const THUMBNAIL = 'assets/images/thumbnail.png';

export const SUPER_ADMIN_PERMISSION = 'SUPER_ADMIN';

export const CENSOR_MANAGEMENT_PERMISSION = {
  censorAccess: 'SOCIAL_CENSOR_ACCESS',
  censorAddUser: 'SOCIAL_CENSOR_ADD_USER',
  censorViewPerformance: 'SOCIAL_CENSOR_VIEW_PERFORMANCE'
};

export const APPROVAL_OTA_TAKE_ACTION_PERMISSION = {
  approvalOtaApprove: 'APPROVAL_APPROVAL_OTA_APPROVE',
  approvalOtaBlock: 'APPROVAL_APPROVAL_OTA_BLOCK',
  approvalOtaDelete: 'APPROVAL_APPROVAL_OTA_DELETE',
  approvalOtaKeep: 'APPROVAL_APPROVAL_OTA_KEEP',
  approvalOtaReject: 'APPROVAL_APPROVAL_OTA_REJECT',
  approvalOtaWarning: 'APPROVAL_APPROVAL_OTA_WARNING'
};

export const APPROVAL_OTA_PERMISSION = {
  ...APPROVAL_OTA_TAKE_ACTION_PERMISSION,
  approvalOtaAccess: 'APPROVAL_APPROVAL_OTA_APPROVAL_LIST'
};

export const APPROVAL_SOCIAL_PERMISSION = {
  approvalMultiDistribution: 'APPROVAL_APPROVAL_MULTI_DISTRIBUTION',
  approvalAccess: 'APPROVAL_APPROVAL_APPROVAL_LIST',
  approvalDelete: 'APPROVAL_APPROVAL_DELETE',
  approvalWarning: 'APPROVAL_APPROVAL_WARNING',
  approvalSuggest: 'APPROVAL_APPROVAL_SUGGEST',
  approvalKeep: 'APPROVAL_APPROVAL_KEEP',
  approvalSkip: 'APPROVAL_APPROVAL_SKIP',
  approvalBlock: 'APPROVAL_APPROVAL_BLOCK',
  approvalDistributeGreenLevels: 'APPROVAL_APPROVAL_DISTRIBUTE_GREEN_LEVELS',
  approvalDistributeYellowLevels: 'APPROVAL_APPROVAL_DISTRIBUTE_YELLOW_LEVELS',
  approvalDistributeRedLevels: 'APPROVAL_APPROVAL_DISTRIBUTE_RED_LEVELS',
  approvalReject: 'APPROVAL_APPROVAL_REJECT',
  approvalApprove: 'APPROVAL_APPROVAL_APPROVE',
  approvalEndLive: 'APPROVAL_APPROVAL_END_LIVESTREAM',
  reviewAccess: 'APPROVAL_REVIEW_REVIEW_LIST',
  reviewDelete: 'APPROVAL_REVIEW_DELETE',
  reviewWarning: 'APPROVAL_REVIEW_WARNING',
  reviewSuggest: 'APPROVAL_REVIEW_SUGGEST',
  reviewKeep: 'APPROVAL_REVIEW_KEEP',
  reviewSkip: 'REVIEW_REVIEW_SKIP', //TODO: Deprecated - Should remove
  reviewBlock: 'APPROVAL_REVIEW_BLOCK',
  reviewReject: 'APPROVAL_REVIEW_REJECT',
  reviewApprove: 'APPROVAL_REVIEW_APPROVE',
  reviewEndLive: 'APPROVAL_REVIEW_END_LIVESTREAM'
};

export const PERMISSION_CODE = {
  superAdmin: SUPER_ADMIN_PERMISSION,
  ...APPROVAL_SOCIAL_PERMISSION,
  ...APPROVAL_OTA_PERMISSION,
  ...CENSOR_MANAGEMENT_PERMISSION
};

export const APPROVAL_SOCIAL_PERMISSION_PRIORITY = {
  [APPROVAL_SOCIAL_PERMISSION.approvalDistributeGreenLevels]: 'GREEN',
  [APPROVAL_SOCIAL_PERMISSION.approvalDistributeYellowLevels]: 'YELLOW',
  [APPROVAL_SOCIAL_PERMISSION.approvalDistributeRedLevels]: 'RED'
};

export const TAG_STYLE_CLASS = {
  blue: 'bg-palette-blue-100 text-palette-blue-600',
  green: 'bg-palette-green-50 text-palette-green-600',
  orange: 'bg-palette-amber-50 text-palette-amber-600',
  red: 'bg-palette-red-50 text-palette-red-600',
  purple: 'bg-palette-violet-50 text-palette-violet-600',
  gray: 'bg-palette-gray-50 text-palette-gray-700',
  moreGray: 'bg-palette-gray-100 text-palette-gray-700'
};

export const TAG_CONTEXTS = {
  new: {
    value: 'NEW',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.NEW',
    styleClass: TAG_STYLE_CLASS.blue
  },
  edit: {
    value: 'EDIT',
    nextValue: 'EDITED',
    label: 'COMMON.EDIT',
    styleClass: TAG_STYLE_CLASS.purple
  },
  edited: {
    value: 'EDITED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.EDITED',
    styleClass: TAG_STYLE_CLASS.purple
  },
  report: {
    value: 'REPORT',
    label: 'ACTIVITY_LOG.ACTIVITY_LABEL.REPORT',
    styleClass: TAG_STYLE_CLASS.orange
  },
  reporting: {
    value: 'REPORTING',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.REPORTING',
    styleClass: TAG_STYLE_CLASS.orange
  },
  reported: {
    value: 'REPORTED',
    label: 'ENTITY_OVERVIEW.REPORTED',
    styleClass: TAG_STYLE_CLASS.orange
  },
  approve: {
    value: 'APPROVE',
    nextValue: 'APPROVED',
    label: 'APPROVAL_REQUESTS.VERIFICATION_REQUEST.REPORT_SUMMARY.APPROVE',
    styleClass: TAG_STYLE_CLASS.blue
  },
  approved: {
    value: 'APPROVED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.APPROVED',
    styleClass: TAG_STYLE_CLASS.blue
  },
  keep: {
    value: 'KEEP',
    nextValue: 'KEPT',
    label: 'COMMON.KEEP',
    styleClass: TAG_STYLE_CLASS.blue
  },
  kept: {
    value: 'KEPT',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.KEPT',
    styleClass: TAG_STYLE_CLASS.blue
  },
  legalApprove: {
    value: 'LEGAL_APPROVE',
    nextValue: 'LEGAL_APPROVED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.LEGAL_APPROVE',
    styleClass: TAG_STYLE_CLASS.blue
  },
  legalApproved: {
    value: 'LEGAL_APPROVED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.LEGAL_APPROVED',
    shortenLabel: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.APPROVED',
    styleClass: TAG_STYLE_CLASS.blue
  },
  salesApprove: {
    value: 'SALES_APPROVE',
    nextValue: 'SALES_APPROVED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.SALES_APPROVE',
    styleClass: TAG_STYLE_CLASS.blue
  },
  salesApproved: {
    value: 'SALES_APPROVED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.SALES_APPROVED',
    shortenLabel: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.APPROVED',
    styleClass: TAG_STYLE_CLASS.blue
  },
  reject: {
    value: 'REJECT',
    nextValue: 'REJECTED',
    label: 'APPROVAL_REQUESTS.VERIFICATION_REQUEST.REPORT_SUMMARY.REJECT',
    styleClass: TAG_STYLE_CLASS.red
  },
  rejected: {
    value: 'REJECTED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.REJECTED',
    styleClass: TAG_STYLE_CLASS.red
  },
  block: {
    value: 'BLOCK',
    nextValue: 'BLOCKED',
    label: 'COMMON.BLOCK',
    styleClass: TAG_STYLE_CLASS.red
  },
  blocked: {
    value: 'BLOCKED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.BLOCKED',
    styleClass: TAG_STYLE_CLASS.red
  },
  delete: {
    value: 'DELETE',
    nextValue: 'DELETED',
    label: 'COMMON.DELETE',
    styleClass: TAG_STYLE_CLASS.red
  },
  deleted: {
    value: 'DELETED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.DELETED',
    styleClass: TAG_STYLE_CLASS.red
  },
  pending: {
    value: 'PENDING',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.PROCESS_FILTER.PENDING',
    styleClass: TAG_STYLE_CLASS.orange
  },
  pendingReview: {
    value: 'PENDING_REVIEW',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.PROCESS_FILTER.PENDING_REVIEW',
    shortenLabel: 'APPROVAL_REQUESTS.APPROVAL_LIST.PROCESS_FILTER.PENDING',
    styleClass: TAG_STYLE_CLASS.orange
  },
  inReview: {
    value: 'INREVIEW',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.PROCESS_FILTER.INREVIEW',
    styleClass: TAG_STYLE_CLASS.orange
  },
  warning: {
    value: 'WARNING',
    nextValue: 'WARNED',
    label: 'COMMON.WARNING',
    styleClass: TAG_STYLE_CLASS.orange
  },
  warned: {
    value: 'WARNED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.WARNED',
    styleClass: TAG_STYLE_CLASS.orange
  },
  active: {
    value: 'ACTIVE',
    label: 'USER_PROFILE.STATUS.ACTIVE',
    styleClass: TAG_STYLE_CLASS.green
  },
  inactive: {
    value: 'INACTIVE',
    label: 'USER_PROFILE.STATUS.INACTIVE',
    styleClass: TAG_STYLE_CLASS.gray
  },
  skip: {
    value: 'SKIP',
    nextValue: 'SKIPPED',
    label: 'APPROVAL_REQUESTS.VERIFICATION_REQUEST.REPORT_SUMMARY.SKIP',
    styleClass: TAG_STYLE_CLASS.gray
  },
  skipped: {
    value: 'SKIPPED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.PROCESS_FILTER.SKIPPED',
    styleClass: TAG_STYLE_CLASS.gray
  },
  archived: {
    value: 'ARCHIVED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.PROCESS_FILTER.ARCHIVED',
    styleClass: TAG_STYLE_CLASS.gray
  },
  suggest: {
    value: 'SUGGEST',
    nextValue: 'SUGGESTED',
    label: 'COMMON.SUGGEST',
    styleClass: TAG_STYLE_CLASS.gray
  },
  suggested: {
    value: 'SUGGESTED',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.SUGGESTED',
    styleClass: TAG_STYLE_CLASS.gray
  },
  none: {
    value: 'NONE',
    nextValue: 'NONE',
    label: 'APPROVAL_REQUESTS.APPROVAL_LIST.STATUS_FILTER.NONE',
    styleClass: TAG_STYLE_CLASS.gray
  },
  default: {
    value: '',
    label: '',
    styleClass: TAG_STYLE_CLASS.moreGray
  }
};

export const CAR_OBJECT_TYPES = [
  OBJECT_TYPE.car,
  OBJECT_TYPE.carRating,
  OBJECT_TYPE.requestOpenCar,
  OBJECT_TYPE.carLegal
].map(type => type.toLowerCase());

export const TRAVEL_OBJECT_TYPES = [
  OBJECT_TYPE.tour,
  OBJECT_TYPE.mapPlace,
  OBJECT_TYPE.tourAgency,
  OBJECT_TYPE.tourComment,
  OBJECT_TYPE.tourRating,
  OBJECT_TYPE.pricingTour,
  OBJECT_TYPE.tourLegal
].map(type => type.toLowerCase());

export const PRIORITY_CONTEXT = {
  green: {
    label: 'HIGH',
    color: 'bg-palette-emerald-600',
    code: 'GREEN'
  },
  yellow: {
    label: 'MEDIUM',
    color: 'bg-palette-yellow-500',
    code: 'YELLOW'
  },
  red: {
    label: 'LOW',
    color: 'bg-palette-red-600',
    code: 'RED'
  }
};

export const MODERATE_MODULE = {
  social: 'SOCIAL',
  ota: 'OTA'
};

export const SOCIAL_MODULES = [
  'POST',
  'COMMENT',
  'VERIFICATION_REQUEST',
  'FANPAGE',
  'GROUP',
  'PROFILE',
  'ADVERTISEMENT',
  'BUSINESS_AD_ACCOUNT_VERIFICATION',
  'LIVESTREAM',
  'STORY',
  'REEL'
];

export const AVAILABLE_I18N_CATEGORIES = [
  'ARTIST_BAND_OR_PUBLIC_FIGURE',
  'BRAND_OF_PRODUCT',
  'BUSINESS_BRAND_ORGANISATION',
  'COMMUNITY',
  'COMPANY_ORGANIZATION_OR_INSTITUTION',
  'DIGITAL_CREATOR_BLOGGER_INFLUENCER',
  'ENTERTAINMENT',
  'FASHION',
  'GAMER',
  'GAMES_OR_APPS',
  'GOVERNMENT_AND_POLITICS',
  'LOCAL_BUSINESS_OR_PLACE',
  'MUSIC',
  'NEWS_AND_MEDIA',
  'NEWS_MEDIA',
  'SPORTS',
  'OTHER'
];

export const TRANSLATED_POLICY_LIST = [
  'VERIFY_ACCOUNT_ACCURACY_',
  'VERIFY_BUSINESS_ACTIVITY',
  'VERIFY_BUSINESS_IDENTIFY',
  'VERIFY_USER_ACTIVITY',
  'VERIFY_USER_FOLLOWERS',
  'VERIFY_USER_IDENTIFY',
  'VERIFY_USER_PERSONAL_INFORMATION'
];
